<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/toolbox-icon.svg" alt="">
    </div>
    Envases
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Editar envase</h2>
    <a routerLink="/containers" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <form [formGroup]="containerForm" (ngSubmit)="onSubmit()">
      <div class="mb-4">
        <label for="codOxy" class="block text-sm font-bold mb-2">Código Oxy<span class="text-danger-500">*</span>:</label>
        <input id="codOxy" type="text" formControlName="codOxy" class="input" placeholder="Código Oxy">
        <div *ngIf="containerForm.get('codOxy')?.invalid && (containerForm.get('codOxy')?.dirty || containerForm.get('codOxy')?.touched)" class="text-danger-500 text-sm">
          El código Oxy es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="codRed" class="block text-sm font-bold mb-2">Código Red<span class="text-danger-500">*</span>:</label>
        <input id="codRed" type="text" formControlName="codRed" class="input" placeholder="Código Red">
        <div *ngIf="containerForm.get('codRed')?.invalid && (containerForm.get('codRed')?.dirty || containerForm.get('codRed')?.touched)" class="text-danger-500 text-sm">
          El código Red es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="typeContainerId" class="block text-sm font-bold mb-2">Tipo de Envase<span class="text-danger-500">*</span>:</label>
        <select id="typeContainerId" formControlName="typeContainerId" class="input">
          <option value="" disabled>Seleccione un tipo de envase</option>
          <option *ngFor="let containerType of containerTypes" [value]="containerType.id">{{ containerType.name }}</option>
        </select>
        <div *ngIf="containerForm.get('typeContainerId')?.invalid && (containerForm.get('typeContainerId')?.dirty || containerForm.get('typeContainerId')?.touched)" class="text-danger-500 text-sm">
          El Tipo de Envase es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="nroSerie" class="block text-sm font-bold mb-2">Número de Serie<span class="text-danger-500">*</span>:</label>
        <input id="nroSerie" type="text" formControlName="nroSerie" class="input" placeholder="Número de Serie">
        <div *ngIf="containerForm.get('nroSerie')?.invalid && (containerForm.get('nroSerie')?.dirty || containerForm.get('nroSerie')?.touched)" class="text-danger-500 text-sm">
          El número de serie es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label for="clientId" class="block text-sm font-bold mb-2">Cliente<span class="text-danger-500">*</span>:</label>
        <select id="clientId" formControlName="clientId" class="input">
          <option value="" disabled>Seleccione un cliente</option>
          <option *ngFor="let client of clients" [value]="client.id">{{ client.razonSocial }}</option>
        </select>
        <div *ngIf="containerForm.get('clientId')?.invalid && (containerForm.get('clientId')?.dirty || containerForm.get('clientId')?.touched)" class="text-danger-500 text-sm">
          El Cliente es obligatorio.
        </div>
      </div>

   
      <div class="mb-4">
        <label for="containerOwnerId" class="block text-sm font-bold mb-2">Propietario<span class="text-danger-500">*</span>:</label>
        <select id="containerOwnerId" formControlName="containerOwnerId" class="input">
          <option value="" disabled>Seleccione un propietario</option>
          <option *ngFor="let item of containerOwners" [value]="item.id">{{ item.name }}</option>
        </select>
        <div *ngIf="containerForm.get('containerOwnerId')?.invalid && (containerForm.get('containerOwnerId')?.dirty || containerForm.get('containerOwnerId')?.touched)" class="text-danger-500 text-sm">
          El Propietario es obligatorio.
        </div>
      </div>

      <div class="mb-4">
        <label for="dateFabrication" class="block text-sm font-bold mb-2">Fecha de Fabricación<span class="text-danger-500">*</span>:</label>
        <input id="dateFabrication" type="date" formControlName="dateFabrication" class="input">
        <div *ngIf="containerForm.get('dateFabrication')?.invalid && (containerForm.get('dateFabrication')?.dirty || containerForm.get('dateFabrication')?.touched)" class="text-danger-500 text-sm">
          La fecha de fabricación es obligatoria.
        </div>
      </div>
      <div class="mb-4">
        <label for="dateHydraulicTest" class="block text-sm font-bold mb-2">Fecha de Prueba Hidráulica<span class="text-danger-500">*</span>:</label>
        <input id="dateHydraulicTest" type="date" formControlName="dateHydraulicTest" class="input">
        <div *ngIf="containerForm.get('dateHydraulicTest')?.invalid && (containerForm.get('dateHydraulicTest')?.dirty || containerForm.get('dateHydraulicTest')?.touched)" class="text-danger-500 text-sm">
          La fecha de prueba hidráulica es obligatoria.
        </div>
      </div>
      <div class="mb-4">
        <label for="tara" class="block text-sm font-bold mb-2">Tara<span class="text-danger-500">*</span>:</label>
        <input id="tara" type="text" formControlName="tara" class="input" placeholder="Tara">
        <div *ngIf="containerForm.get('tara')?.invalid && (containerForm.get('tara')?.dirty || containerForm.get('tara')?.touched)" class="text-danger-500 text-sm">
          La tara es obligatoria.
        </div>
      </div>    
      <div *ngIf="errorMessage" class="mb-4 text-danger-500">
        {{ errorMessage }}
      </div>
      <div class="flex items-center justify-end">
        <button type="submit" class="button button-success">
          Actualizar envase
        </button>
      </div>
    </form>
  </div>
</div>
